<template>
  <div class="contentdetail" v-if="!reviewInfo.checkFlag">
    <div class="content-container">
      <div v-if="article.docType == 1" class="warp" :style="{ height: isOpen ? 'auto' : '40px' }">
        <p class="text" :class="isOpen ? '' : 'clamp'">
          审核状态：<span>{{ state }}</span>
          <template v-if="reviewInfo.reviewStatus > 1">
            审核意见：<span>{{ reviewInfo.reviewRemark }}</span>
          </template>
          <template v-if="reviewInfo.reviewImg">
            <p style="padding-top: 4px;">
              <img :src="reviewInfo.reviewImg" :width="100" :height="100" :preview="false" class="preview-img" @click="handlePreview(reviewInfo.reviewImg)">
            </p>
          </template>
        </p>
        <span class="butn" @click="isOpen = !isOpen" v-if="reviewInfo.reviewStatus > 1">
            <a-icon :type="isOpen ? 'up' : 'down'"/>
          </span>
      </div>
      <!-- 图片预览模态框 -->
      <a-modal v-model="previewVisible" :footer="null" :width="800" title="图片预览" @cancel="previewVisible = false">
        <img :src="previewImage" alt="预览图片" style="max-width: 100%;" />
      </a-modal>

      <div class="cl">
        <div class="title text-center">{{ article.title }}</div>
        <div class="author text-center margin-top-10 margin-bottom-20">
          发布者:<span class="margin-left-small margin-right-10">{{ article.author }}</span>
          <i class="iconfont icon-yanjing1"></i>
          <span>发布时间：{{ article.publishTime }}</span>
        </div>
        <div class="desc" v-html="article.content"></div>
      </div>
      <div class="studentinfomation" v-if="article.docList && article.docList.length > 0">
        <div class="">此文档包含以下附件:</div>
        <div style="margin-top: 16px;">
          <a-row class="docList" :gutter="[24, 24]">
            <a-col :span="8" v-for="item in article.docList" :key="item.id">
              <div class="filestyle" @click="downloadDoc(item.docUrl, item.docName)">
                <div
                  class="defaultcss"
                  :class="{
                    pdfcss: item.docName.includes('pdf'),
                    doccss: item.docName.includes('doc'),
                    xlscss: item.docName.includes('xls')
                  }"
                >
                  <span>{{ item.docName }}</span>
                </div>
                <div class="downicon">
                  <img src="../../../assets/images/downicon.png" />
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>

    <div class="upfile" v-if=" timeState !== '未开始' && article.docType == 1">
      <div style="margin-bottom: 12px">
        <span style="font-weight: bolder;">我的回传文件</span>
        <div class="pull-right">
          <div class="rightinfo">
            <a-button
              v-if="timeState === '进行中' && reviewInfo.reviewStatus != '2'"
              type="primary"
              shape="round"
              class="btn"
              :loading="loading"
              @click="handleSubmit"
              >全部提交</a-button>
          </div>
        </div>
      </div>
      <div class="margin-bottom-20" style="clear: both">
        <div class="visibles" v-if="article.visibles && article.visibles.length > 0">
          <a-form-model ref="form" :model="formData" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-row>
              <a-col :span="12" v-for="item in article.visibles" :key="item.label" style="height:50px;">
                <a-form-model-item
                    v-if="item.show"
                    :label="item.title"
                    :prop="item.label"
                    :rules="[{ required: item.required, message: `${item.title}不能为空` }]"
                >
                  <!-- 日期选择框 -->
                  <a-date-picker v-if="item.type == 'date'" valueFormat="YYYY-MM-DD" v-model="formData[item.label]" placeholder="请选择" style="width: 100%" />
                  <!-- 数字输入框 -->
                  <a-input-number v-if="item.type == 'number'" v-model.trim="formData[item.label]" placeholder="请输入" :min="0" :max="100" style="width: 100%"/>
                  <!-- 单选框 -->
                  <j-dict-select-tag v-if="item.type == 'radio'" type="radio" v-model="formData[item.label]" :dictCode="item.dictCode" />
                  <!-- 下拉选择 -->
                  <j-dict-select-tag v-if="item.type == 'select'" type="select" v-model="formData[item.label]" :dictCode="item.dictCode" placeholder="请选择" />
                  <!-- 下拉多选 -->
                  <j-multi-select-tag v-if="item.type == 'mutiSelect'" type="multi" v-model="formData[item.label]" :dictCode="item.dictCode" placeholder="请选择" />
                  <!-- 文本输入框 -->
                  <a-input v-if="item.type == 'text'" v-model.trim="formData[item.label]" placeholder="请输入" allowClear />
                  <!-- 多行文本输入框 -->
                  <a-textarea v-if="item.type == 'textarea'" v-model.trim="formData[item.label]" placeholder="请输入" showCount :rows="3" :maxlength="200" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <div class="uploadarea" v-if="article.configList && article.configList.length > 0">
          <docUpload
            required
            v-for="item in article.configList"
            :key="item.id"
            :info="item"
            @change="onFileChange"
            @remove="onFileRemove"
            @changeDesc="onChangeDesc"
            :state="reviewInfo.reviewStatus"
          ></docUpload>
        </div>
        <div class="uploadarea" v-else>
          <docUpload required :info="uploadItemDefault" @change="onFileChange" @remove="onFileRemove" :state="reviewInfo.reviewStatus" />
        </div>
      </div>
    </div>
  </div>
  <div v-else style="text-align: center;margin: 100px 0 ;color:red;font-size: 20px;font-weight: bolder;">
    {{reviewInfo.checkMsg}}
  </div>
</template>

<script>
import docUpload from './docListUpload'

export default {
  name: 'DetailList',
  props: {
    article: Object,
    reviewInfo: Object
  },
  components: {
    docUpload
  },
  watch: {
    'article.visibles': {
      handler(newVal) {
        if (newVal && newVal.length) {
          newVal.forEach(item => {
            if (item.show) {
              this.$set(this.formData, item.label, item.value)
            }
          })
          // this.formData = {...modal}
        }
      },
      deep: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'visibles' }),
      bid: this.$route.query.bid,
      pgType: this.$route.query.pt || null,
      formData: {},
      delFileIds: [],
      fileList: [],
      loading: false,
      isOpen: true,
      previewVisible: false,
      previewImage: ''
    }
  },
  computed: {
    state() {
      const statusEnum = {
        0: '待提交',
        1: '待审核',
        2: '审核通过',
        3: '部分通过',
        4: '审核驳回'
      }
      return statusEnum[this.reviewInfo.reviewStatus || '0']
    },
    uploadItemDefault() {
      return {
        fileTitle: '文件上传',
        isInput: 0,
        fileSize: 20,
        fileNumber: 10,
        fileList: this.reviewInfo.docList || []
      }
    },
    timeState() {
      // 将字符串日期转换为Date对象
      const startTime = new Date(this.article.beginTime)
      const endingTime = new Date(this.article.endTime)
      const currentTime = new Date()

      // 比较时间
      if (currentTime >= startTime && currentTime <= endingTime) {
        return '进行中'
      } else if (currentTime < startTime) {
        return '未开始'
      } else {
        return '已结束'
      }
    }
  },
  methods: {
    handlePreview(imgUrl) {
      this.previewImage = imgUrl
      this.previewVisible = true
    },
    backHistory() {
      this.$router.go(-1) // 返回上一层
    },
    downloadDoc(url, name) {
      this.axios
        .get(url, {
          responseType: 'blob'
        })
        .then(res => {
          const url = window.URL.createObjectURL(res)
          const el = document.createElement('a')
          el.setAttribute('href', url)
          el.setAttribute('download', name)
          el.style.display = 'none'
          document.body.appendChild(el)
          el.click()
          document.body.removeChild(el)
        })
    },
    handleSubmit() {
      if (this.$refs.form) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            this.$message.error('表单必填项不能为空')
            return false
          }
        })
      } else {
        if (this.fileList.length === 0) {
          this.$message.error('请添加上传附件')
          return false
        }
        this.submit()
      }
    },
    submit() {
      let params = {
        id: this.article.id,
        docList: this.fileList || [],
        delFileIds: this.delFileIds.join(','),
        docStuInfo: this.formData
      }
      // 待办提交属性
      params.businessId = this.bid
      params.pgType = this.pgType

      this.loading = true
      this.axios.post('/biz/home/document/backUpload', params).then(res => {
        if (res.success) {
          this.$message.success(res.result)
          setTimeout(() => {
            if (this.bid && this.pgType === 'todo') {
              this.$router.push({path: '/todos/list'})
            } else {
              this.$router.go(0)
            }
          }, 1000)
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark
      })
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex(item => item.uid === uid)
      this.fileList.splice(index, 1)
      if (id) this.delFileIds.push(id)
    },
    onChangeDesc({ configId, desc }) {
      this.fileList.forEach(item => {
        if (item.configId === configId) {
          item.remark = desc
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.content-container
  background-color #FFFFFF
.upfile
  background-color #FFFFFF
  margin-top 20px
  padding 28px

.title
  font-size 24px
  margin-top 30px


.author
  font-size 13px
  color #999


.cl
  clear both
  padding 28px


.desc
  line-height 30px
  color $fontGray
  text-indent 2em
  padding-top 20px


.contentdetail
  margin-bottom 20px

.text
  font-size 14px
  text-align justify
  line-height 1.5
  float left
  line-height 24px
.text span
  color #fc484e
  margin-right 10px



.warp
  background-color #fefaed
  line-height 30px
  display inline-block
  position relative
  padding 10px 20px
  padding-right 60px
  width 100%
  transition height .3s


.clamp
  padding-right 60px
  overflow hidden
  display -webkit-box
  -webkit-line-clamp 1
  -webkit-box-orient vertical


.butn
  position absolute
  right 20px
  top 8px
  color #2caf7a
  cursor pointer

.docList{
  display flex
  flex-wrap wrap
}


.studentinfomation
  background-color #FFF
  width 100%
  display inline-block
  padding 28px
  padding-top 0px

.filestyle
  border-radius 10px
  border #eef1f1 solid 1px
  padding 20px
  width 100%
  height 100%
  display inline-block
  cursor pointer
  // margin-right 20px
  // margin-top 20px
.defaultcss{
  background url("../../../assets/images/defaulticon.png") no-repeat left center
  padding-left 46px
  float left
  height 30px
}
.pdfcss
  background-image url("../../../assets/images/pdficon.png")


.progressbar
  width 100%
  clear both
  padding-top 10px


.filegrey
  font-size 12px
  color #b2b2b2
  line-height 26px

.filestyle
  span
    display block

.downicon
  float right
  width 22px
  height 22px
  cursor pointer

.doccss
  background-image url("../../../assets/images/docicon.png")

.xlscss
  background-image url("../../../assets/images/xlsicon.png")


.uploadarea
  margin-top 20px
  background-color #fbfcfc



.uploadicon
  background url("../../../assets/images/uploadicon.png") no-repeat left center
  padding-left 26px


.btn
  background-color $bgColor
  border:$bgColor solid 1px
  margin-right 14px

.progressbar
  width 100%
  clear both
  padding-top 10px
</style>
<style lang="css" scoped>
.desc >>> strong{
  font-weight: bold;
}
.ant-form-item {
  margin-bottom: 0;
}
.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 0;
}
.visibles >>> .ant-form-item-label {
  margin-right: 4px;
}
.visibles >>> .ant-form-item-label > label {
  white-space: pre-wrap; /* 或者使用 'normal' */
  word-break: break-all;
  line-height: 18px;
}

.preview-img {
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}
.preview-img:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/pages/documentDetail/components/DetailList.vue